module.exports = __webpack_public_path__ + "img/logo bioherbs-01.bb06d8fd.png";